import script from "./PickRestaurantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PickRestaurantModal.vue?vue&type=script&setup=true&lang=js"

import "./PickRestaurantModal.vue?vue&type=style&index=0&id=173664cc&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173664cc"]])

export default __exports__